
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const UserRoleEnum = {
  USER: 'USER',
  ADMIN: 'ADMIN'
} as const

export type UserRoleEnum = (typeof UserRoleEnum)[keyof typeof UserRoleEnum]


export const InviteStatusEnum = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  EXPIRED: 'EXPIRED'
} as const

export type InviteStatusEnum = (typeof InviteStatusEnum)[keyof typeof InviteStatusEnum]


export const McpModeEnum = {
  DISABLED: 'DISABLED',
  DRAFT: 'DRAFT',
  DIRECT: 'DIRECT'
} as const

export type McpModeEnum = (typeof McpModeEnum)[keyof typeof McpModeEnum]


export const McpDraftKind = {
  SUBSUBSECTION_UPDATE: 'SUBSUBSECTION_UPDATE',
  SUBSUBSECTION_CREATE: 'SUBSUBSECTION_CREATE',
  SUBSECTION_UPDATE: 'SUBSECTION_UPDATE',
  SUBSECTION_CREATE: 'SUBSECTION_CREATE',
  PROJECT_RECORD_UPDATE: 'PROJECT_RECORD_UPDATE',
  PROJECT_RECORD_CREATE: 'PROJECT_RECORD_CREATE'
} as const

export type McpDraftKind = (typeof McpDraftKind)[keyof typeof McpDraftKind]


export const StateKeyEnum = {
  BADEN_WUERTTEMBERG: 'BADEN_WUERTTEMBERG',
  BAYERN: 'BAYERN',
  BERLIN: 'BERLIN',
  BRANDENBURG: 'BRANDENBURG',
  BREMEN: 'BREMEN',
  HAMBURG: 'HAMBURG',
  HESSEN: 'HESSEN',
  MECKLENBURG_VORPOMMERN: 'MECKLENBURG_VORPOMMERN',
  NIEDERSACHSEN: 'NIEDERSACHSEN',
  NORDRHEIN_WESTFALEN: 'NORDRHEIN_WESTFALEN',
  RHEINLAND_PFALZ: 'RHEINLAND_PFALZ',
  SAARLAND: 'SAARLAND',
  SACHSEN: 'SACHSEN',
  SACHSEN_ANHALT: 'SACHSEN_ANHALT',
  SCHLESWIG_HOLSTEIN: 'SCHLESWIG_HOLSTEIN',
  THUERINGEN: 'THUERINGEN',
  DISABLED: 'DISABLED'
} as const

export type StateKeyEnum = (typeof StateKeyEnum)[keyof typeof StateKeyEnum]


export const MembershipRoleEnum = {
  VIEWER: 'VIEWER',
  EDITOR: 'EDITOR'
} as const

export type MembershipRoleEnum = (typeof MembershipRoleEnum)[keyof typeof MembershipRoleEnum]


export const LabelPositionEnum = {
  top: 'top',
  topRight: 'topRight',
  right: 'right',
  bottomRight: 'bottomRight',
  bottom: 'bottom',
  bottomLeft: 'bottomLeft',
  left: 'left',
  topLeft: 'topLeft'
} as const

export type LabelPositionEnum = (typeof LabelPositionEnum)[keyof typeof LabelPositionEnum]


export const PriorityEnum = {
  OPEN: 'OPEN',
  TOP: 'TOP',
  HIGH: 'HIGH',
  MEDIUM: 'MEDIUM',
  LOW: 'LOW'
} as const

export type PriorityEnum = (typeof PriorityEnum)[keyof typeof PriorityEnum]


export const GeometryTypeEnum = {
  POINT: 'POINT',
  LINE: 'LINE',
  POLYGON: 'POLYGON'
} as const

export type GeometryTypeEnum = (typeof GeometryTypeEnum)[keyof typeof GeometryTypeEnum]


export const LocationEnum = {
  URBAN: 'URBAN',
  RURAL: 'RURAL'
} as const

export type LocationEnum = (typeof LocationEnum)[keyof typeof LocationEnum]


export const SubsectionStatusStyleEnum = {
  REGULAR: 'REGULAR',
  DASHED: 'DASHED'
} as const

export type SubsectionStatusStyleEnum = (typeof SubsectionStatusStyleEnum)[keyof typeof SubsectionStatusStyleEnum]


export const SubsubsectionStatusStyleEnum = {
  REGULAR: 'REGULAR',
  GREEN: 'GREEN'
} as const

export type SubsubsectionStatusStyleEnum = (typeof SubsubsectionStatusStyleEnum)[keyof typeof SubsubsectionStatusStyleEnum]


export const SurveyResponseSourceEnum = {
  EMAIL: 'EMAIL',
  LETTER: 'LETTER',
  FORM: 'FORM'
} as const

export type SurveyResponseSourceEnum = (typeof SurveyResponseSourceEnum)[keyof typeof SurveyResponseSourceEnum]


export const SurveyResponseStateEnum = {
  CREATED: 'CREATED',
  SUBMITTED: 'SUBMITTED'
} as const

export type SurveyResponseStateEnum = (typeof SurveyResponseStateEnum)[keyof typeof SurveyResponseStateEnum]


export const SystemLogLevelEnum = {
  INFO: 'INFO',
  ERROR: 'ERROR'
} as const

export type SystemLogLevelEnum = (typeof SystemLogLevelEnum)[keyof typeof SystemLogLevelEnum]


export const LogLevelActionEnum = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE'
} as const

export type LogLevelActionEnum = (typeof LogLevelActionEnum)[keyof typeof LogLevelActionEnum]


export const ProjectRecordEditingState = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED'
} as const

export type ProjectRecordEditingState = (typeof ProjectRecordEditingState)[keyof typeof ProjectRecordEditingState]


export const ProjectRecordType = {
  SYSTEM: 'SYSTEM',
  USER: 'USER'
} as const

export type ProjectRecordType = (typeof ProjectRecordType)[keyof typeof ProjectRecordType]


export const ProjectRecordReviewState = {
  NEEDSREVIEW: 'NEEDSREVIEW',
  NEEDSADMINREVIEW: 'NEEDSADMINREVIEW',
  REJECTED: 'REJECTED',
  APPROVED: 'APPROVED'
} as const

export type ProjectRecordReviewState = (typeof ProjectRecordReviewState)[keyof typeof ProjectRecordReviewState]


export const TagColorEnum = {
  LIGHT_BLUE: 'LIGHT_BLUE',
  BLUE: 'BLUE',
  VIOLET: 'VIOLET',
  PINK: 'PINK',
  RED: 'RED',
  ORANGE: 'ORANGE',
  YELLOW: 'YELLOW',
  LIME: 'LIME',
  MINT: 'MINT',
  CYAN: 'CYAN'
} as const

export type TagColorEnum = (typeof TagColorEnum)[keyof typeof TagColorEnum]


export const FormTemplateTypeEnum = {
  SUBSUBSECTION: 'SUBSUBSECTION',
  ACQUISITIONAREA: 'ACQUISITIONAREA'
} as const

export type FormTemplateTypeEnum = (typeof FormTemplateTypeEnum)[keyof typeof FormTemplateTypeEnum]
